var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
// module id = null
// module chunks = 